//post actions
export const FETCHFEED = "FETCH_FEED";
export const FETCHSINGLEPOST = "FETCH_SINGLE_POST";
export const CREATEPOST = "CREATE";
export const UPDATEPOST = "UPDATE";
export const DELETEPOST = "DELETE";
export const LIKEPOST = "LIKE";
export const DISLIKEPOST = "DISLIKE";
export const FETCHCOMMENTS = "FETCHCOMMENTS";
export const COMMENTPOST = "COMMENTPOST";
export const REPLYCOMMENT = "REPLYCOMMENT";
export const LIKECOMMENT = "LIKECOMMENT";
export const DISLIKECOMMENT = "DISLIKECOMMENT";

//search actions
export const SEARCH_POST = "SEARCH_POST";

//loading actions
export const START_LOADING = "START_LOADING";
export const END_LOADING = "END_LOADING";
export const START_LOAD_SINGLEPOST = "START_LOAD_SINGLEPOST";
export const END_LOAD_SINGLEPOST = "END_LOAD_SINGLEPOST";
export const START_FETCH_COMMENT_LOAD = "START_FETCH_COMMENT_LOAD";
export const END_FETCH_COMMENT_LOAD = "END_COMMENT_LOADING";
export const START_COMMENT_LOADING = "START_COMMENT_LOADING";
export const END_COMMENT_LOADING = "END_COMMENT_LOADING";
export const START_REPLY_LOADING = "START_REPLY_LOADING";
export const END_REPLY_LOADING = "END_REPLY_LOADING";
export const SEARCHBYPOSTNAME = "SEARCHBYPOSTNAME";
export const SEARCHPROFILEBYNAME = "SEARCHPROFILEBYNAME";

//auth actions
export const AUTH = "AUTH";
export const LOGOUT = "LOGOUT";
export const AUTH_ERROR = "AUTH_ERROR";

//profile actions
export const FETCHPROFILE = "FETCH_PROFILE";
export const FETCHUSER = "FETCH_USER";
export const SETPROFILE = "SET_PROFILE";
export const SETCONTENT = "SET_CONTENT";
export const UPDATEPASSWORD = "UPDATE_PASSWORD";
export const UPDATEPASSWORDERRS = "UPDATE_PASSWORD_ERROR";
export const DELETEACCOUNT = "DELETE_ACCOUNT";
export const FOLLOWERSANDFOLLOWING = "FOLLOWERSANDFOLLOWING";
export const ADDTOLIBRARY = "ADDTOLIBRARY";
export const SEARCHLIBRARY = "SEARCHLIBRARY";
export const DELETEALLIBRARY = "DELETEALLIBRARY";
export const REMOVEDPOSTFROMLIBRARY = "REMOVEDPOSTFROMLIBRARY";

//frontend actions
export const OPEN_EMAIL_BOX = "OpenEMAILBox";
export const CLOSE_EMAIL_BOX = "CloseEMAILBox";
export const MENU_OPEN = "MENU_OPEN";
export const MENU_CLOSE = "MENU_CLOSE";

//search actions
export const LIBRARY_SEARCH_TRUE = "LIBRARY_SEARCH_TRUE";
export const LIBRARY_SEARCH_FALSE = "LIBRARY_SEARCH_FALSE";
export const START_LIBRARY_LOADING = "START_LIBRARY_LOADING";
export const END_LIBRARY_LOADING = "END_LIBRARY_LOADING";

//MESSAGES
export const SUCCESS_MESSAGE = "SUCCESS_MESSAGE";
export const FAILURE_MESSAGE = "FAILURE_MESSAGE";
export const SHOW_ALERT = "SHOW_ALERT";
export const ACTION_OKAY = "ACTION_OKAY";
export const ACTION_COMPLETED='ACTION_COMPLETED'
export const ACTION_CANCEL = "ACTION_CANCEL";
